import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TranslationKeyMap } from '../coaching-insight.i18n';

import { MAX_SHOWABLE_RANGE } from './coaching-coverage.model';

@Component({
    selector: '[cmpsSelectPeriodRange]',
    template: ` <div class="spr-container">
        <cmps-radio-group
            class="d-flex flex-column"
            [value]="selection"
            (change)="selectionChange.emit($event)"
        >
            <ng-container *ngFor="let i of _weeks">
                <cmps-radio
                    [value]="i"
                    color="primary"
                >
                    <span [class.spr-selected]="i === selection"
                        >{{ i }}&nbsp;{{ _i18n._9607_WEEKS | translate }}</span
                    >
                </cmps-radio>
            </ng-container>
        </cmps-radio-group>
    </div>`,
    host: {
        'data-e2e': 'component-select-period-range',
    },
})
export class SelectPeriodRangeComponent {
    /** @private */ _i18n = TranslationKeyMap;

    /** @private */ _weeks: number[]; // TODO revise. don't know if or how other period types will function
    @Input() selection: number;
    @Output() selectionChange: EventEmitter<number>;

    constructor() {
        this.selectionChange = new EventEmitter();

        this._weeks = new Array(MAX_SHOWABLE_RANGE / 2)
            .fill(null)
            .reduce((p, c, i) => {
                p[i] = (i + 1) * 2;
                return p;
            }, []);
    }
}
